'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLazyHero = require('react-lazy-hero');

var _reactLazyHero2 = _interopRequireDefault(_reactLazyHero);

var _reactParticlesJs = require('react-particles-js');

var _reactParticlesJs2 = _interopRequireDefault(_reactParticlesJs);

var _Container = require('../Container/Container');

var _Container2 = _interopRequireDefault(_Container);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Header = require('../Header/Header');

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hero = function (_Component) {
  _inherits(Hero, _Component);

  function Hero() {
    _classCallCheck(this, Hero);

    return _possibleConstructorReturn(this, (Hero.__proto__ || Object.getPrototypeOf(Hero)).apply(this, arguments));
  }

  _createClass(Hero, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          image = _props.image,
          parallaxOffset = _props.parallaxOffset,
          isFixed = _props.isFixed,
          isCentered = _props.isCentered,
          overlayColor = _props.overlayColor,
          opacity = _props.opacity,
          header = _props.header,
          subHeader = _props.subHeader,
          minHeight = _props.minHeight,
          subHeaderPosition = _props.subHeaderPosition,
          particles = _props.particles,
          particlesParams = _props.particlesParams,
          backgroundColor = _props.backgroundColor,
          buttons = _props.buttons,
          children = _props.children;

      return _react2.default.createElement(
        'div',
        { className: 'Hero', style: { backgroundColor: backgroundColor } },
        _react2.default.createElement(
          _reactLazyHero2.default,
          {
            isFixed: isFixed,
            isCentered: isCentered,
            imageSrc: image,
            opacity: opacity,
            color: overlayColor,
            parallaxOffset: parallaxOffset,
            minHeight: minHeight
          },
          particles && _react2.default.createElement(
            'div',
            { className: 'Hero__Particles' },
            _react2.default.createElement(_reactParticlesJs2.default, { params: particlesParams })
          ),
          _react2.default.createElement(
            'div',
            { className: 'Hero__Container d-flex align-content-center' },
            !children && _react2.default.createElement(
              _Container2.default,
              null,
              subHeader && subHeaderPosition === 'top' && _react2.default.createElement(
                _Header2.default,
                { className: 'Hero__SubHeader mb-5' },
                subHeader
              ),
              header && _react2.default.createElement(
                _Header2.default,
                { className: 'Hero__Header mb-5' },
                header
              ),
              subHeader && subHeaderPosition !== 'top' && _react2.default.createElement(
                _Header2.default,
                { className: 'Hero__SubHeader mb-5' },
                subHeader
              ),
              buttons.map(function (button) {
                return _react2.default.createElement(
                  _Button2.default,
                  {
                    className: 'btn-xl Hero__Button',
                    key: button.text,
                    onClick: function onClick() {
                      return Hero.onButtonClick(button);
                    }
                  },
                  button.text
                );
              })
            ),
            children
          )
        )
      );
    }
  }], [{
    key: 'onButtonClick',
    value: function onButtonClick(button) {
      if (button.onClick && typeof button.onClick === 'function') button.onClick({ button: button });
    }
  }]);

  return Hero;
}(_react.Component);

Hero.propTypes = {
  isFixed: _propTypes2.default.bool,
  isCentered: _propTypes2.default.bool,
  particles: _propTypes2.default.bool,
  opacity: _propTypes2.default.number,
  parallaxOffset: _propTypes2.default.number,
  image: _propTypes2.default.string,
  overlayColor: _propTypes2.default.string,
  header: _propTypes2.default.string,
  subHeader: _propTypes2.default.string,
  subHeaderPosition: _propTypes2.default.string,
  minHeight: _propTypes2.default.string,
  backgroundColor: _propTypes2.default.string,
  buttons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string,
    onClick: _propTypes2.default.func
  })),
  particlesParams: _propTypes2.default.objectOf(_propTypes2.default.any),
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};
Hero.defaultProps = {
  isFixed: true,
  isCentered: true,
  particles: true,
  opacity: 0,
  parallaxOffset: 0,
  image: '',
  overlayColor: '#fff',
  header: '',
  subHeader: '',
  subHeaderPosition: 'bottom',
  minHeight: '100vh',
  backgroundColor: 'transparent',
  buttons: [],
  particlesParams: {},
  children: null
};

exports.default = Hero;